import { useEffect } from "react";
import { MbAnagraficaCausal } from "../mb_anagrafiche/mb_tables/mb_anagrafica_causal";
import { MbMessage } from "../mb_components/mb_message";

const MbValidatorCausal = ({callbackFromValidator}) => {

    return (
        <>
            <MbMessage title="Causale" helper="Selezionare una causale" open isFullscreen>
                <div style={{paddingLeft: "30px", paddingRight: "30px"}}>
                    <MbAnagraficaCausal isValidator callbackFromValidator={(item) => {
                        callbackFromValidator(item);
                    }}/>
                </div>
            </MbMessage>
        </>
    );
};

export {
    MbValidatorCausal
}